
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6156',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6156",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7777",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11193",
  "I18n": "static-7.1562",
  "jasmine-runner": "static-1.6244",
  "quartz": "static-1.6688",
  "quartz-core": "static-1.5907",
  "react-dlb": "static-1.71",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.725",
  "enviro": "static-4.387",
  "foundations-components": "static-1.7467",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11501",
  "icons": "static-2.618",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6934",
  "PortalIdParser": "static-2.349",
  "quartz-config": "static-1.466",
  "quartz-routing": "static-1.118",
  "quick-fetch": "static-1.3707",
  "react": "static-7.177",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16413",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5147",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18332",
  "signup-ui-lego-core": "static-1.20342",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "ui-addon-react-router-dom": "static-1.9320",
  "ui-images": "static-2.1085",
  "UIComponents": "static-3.8140",
  "usage-tracker": "static-1.7104",
  "usage-tracker-core": "static-1.6954",
  "viral-links-lib": "static-1.6802",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "bend-plugin-trellis-migration": "static-1.3202",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2965",
  "quartz-webpack": "static-1.2912",
  "HeadJS": "static-2.704",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2888",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "foundations-theming": "static-1.4181",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4101",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.787",
  "hubspotter-http": "static-1.4451",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.363",
  "quartz-head": "static-1.353",
  "quartz-i18n": "static-1.363",
  "quartz-test": "static-1.363",
  "ui-fonts": "static-1.455",
  "usage-tracker-container": "static-1.7094",
  "sassPrefix": "static-1.151",
  "bend-plugin-foundations-components": "static-1.3736",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4605",
  "foundations-theming-specialty": "static-1.1897",
  "hs-story-utils": "static-1.9200",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1115",
  "superstore": "static-1.4543",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4404",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7837",
  "bender-build-tools": "static-1.2910",
  "bend-plugin-foundations-theming": "static-1.2664",
  "foundations-theming-base": "static-1.3166",
  "stylex": "static-1.27",
  "hub-http-shared-msw-handlers": "static-1.9406",
  "hubspotter-http-shared-msw-handlers": "static-1.9404",
  "ts-schema": "static-1.3878"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6156",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7777",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11193",
  "I18n": "/I18n/static-7.1562",
  "jasmine-runner": "/jasmine-runner/static-1.6244",
  "quartz": "/quartz/static-1.6688",
  "quartz-core": "/quartz-core/static-1.5907",
  "react-dlb": "/react-dlb/static-1.71",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.725",
  "enviro": "/enviro/static-4.387",
  "foundations-components": "/foundations-components/static-1.7467",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11501",
  "icons": "/icons/static-2.618",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6934",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "quartz-config": "/quartz-config/static-1.466",
  "quartz-routing": "/quartz-routing/static-1.118",
  "quick-fetch": "/quick-fetch/static-1.3707",
  "react": "/react/static-7.177",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16413",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5147",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18332",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20342",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9320",
  "ui-images": "/ui-images/static-2.1085",
  "UIComponents": "/UIComponents/static-3.8140",
  "usage-tracker": "/usage-tracker/static-1.7104",
  "usage-tracker-core": "/usage-tracker-core/static-1.6954",
  "viral-links-lib": "/viral-links-lib/static-1.6802",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3202",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2965",
  "quartz-webpack": "/quartz-webpack/static-1.2912",
  "HeadJS": "/HeadJS/static-2.704",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2888",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "foundations-theming": "/foundations-theming/static-1.4181",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4101",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "hubspotter-http": "/hubspotter-http/static-1.4451",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.363",
  "quartz-head": "/quartz-head/static-1.353",
  "quartz-i18n": "/quartz-i18n/static-1.363",
  "quartz-test": "/quartz-test/static-1.363",
  "ui-fonts": "/ui-fonts/static-1.455",
  "usage-tracker-container": "/usage-tracker-container/static-1.7094",
  "sassPrefix": "/sassPrefix/static-1.151",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3736",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4605",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1897",
  "hs-story-utils": "/hs-story-utils/static-1.9200",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1115",
  "superstore": "/superstore/static-1.4543",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4404",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7837",
  "bender-build-tools": "/bender-build-tools/static-1.2910",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2664",
  "foundations-theming-base": "/foundations-theming-base/static-1.3166",
  "stylex": "/stylex/static-1.27",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9406",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9404",
  "ts-schema": "/ts-schema/static-1.3878"
}
};
